import axios, { CancelToken } from 'axios';
import { getToken } from '../../../token';
import { urlHttpGov } from '../../../request/urls';
import { IProposta, IPropostaFilter, ICreatePropostaPayload, IUpdatePropostaPayload } from '../../../../pages/Propostas/interface';

class PropostaService {
    private readonly baseURL = `${urlHttpGov}/proposta-comercial`;

    private getHeaders() {
        return {
            Authorization: `Bearer ${getToken()}`
        };
    }

    async getAllPropostas(filters?: IPropostaFilter, signal?: CancelToken): Promise<IProposta[]> {
        const { data } = await axios.get(`${this.baseURL}`, {
            headers: this.getHeaders(),
            params: filters,
            cancelToken: signal
        });
        if (Array.isArray(data)) {
            return data;
        }
        if (data && Array.isArray(data.data)) {
            return data.data;
        }
        return [];
    }

    async getPropostaById(id: number | string, signal?: CancelToken): Promise<IProposta> {
        const { data } = await axios.get(`${this.baseURL}/${id}`, {
            headers: this.getHeaders(),
            cancelToken: signal
        });
        return data;
    }

    async createProposta(payload: ICreatePropostaPayload): Promise<IProposta> {
        const { data } = await axios.post(`${this.baseURL}`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }

    async updateProposta(id: number | string, payload: IUpdatePropostaPayload): Promise<IProposta> {
        const { data } = await axios.put(`${this.baseURL}/${id}`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }

    async toggleStatusEnvio(id: number | string, enviado: boolean, enviado_para?: string): Promise<IProposta> {
        const { data } = await axios.patch(`${this.baseURL}/${id}/status-envio`, 
            { enviado, enviado_para },
            { headers: this.getHeaders() }
        );
        return data;
    }

    async duplicateProposta(id: number | string): Promise<IProposta> {
        const { data } = await axios.post(`${this.baseURL}/${id}/duplicate`, {}, {
            headers: this.getHeaders()
        });
        return data;
    }

    async deleteProposta(id: number | string): Promise<void> {
        await axios.delete(`${this.baseURL}/${id}`, {
            headers: this.getHeaders()
        });
    }

    async registrarEnvio(propostaId: number | string, payload: { enviado_para: string; observacao?: string; enviado_em?: Date | string }): Promise<IProposta> {
        const { data } = await axios.post(`${this.baseURL}/${propostaId}/envios`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }

    async excluirEnvio(propostaId: number | string, envioId: number | string): Promise<IProposta> {
        const { data } = await axios.delete(`${this.baseURL}/${propostaId}/envios/${envioId}`, {
            headers: this.getHeaders()
        });
        return data;
    }

    async getEnvios(propostaId: number | string): Promise<any[]> {
        const { data } = await axios.get(`${this.baseURL}/${propostaId}/envios`, {
            headers: this.getHeaders()
        });
        return data;
    }
}

export default new PropostaService();
